<link rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
<div class="h-100 mt-20 w-full flex items-center justify-center">
    <div class="w-full max-w-7xl mx-auto px-4">
        <!-- HEADER LOGO -->
        <div class="flex justify-center mb-12">
            <img src="./assets/images/menu/logoKITE.png" alt="KITE Homepage" class="max-w-[150px] md:max-w-[150px] object-contain">
        </div>

        <!-- MENU OPTIONS -->
        <div class="flex flex-wrap justify-center items-center gap-4 md:gap-8">
            <!-- ECO CARD -->
            <div class="w-full sm:w-[270px]" [routerLink]="'/eco/dashboard'">
                <div class="relative group h-[200px] w-full bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer flex items-center justify-center p-6">
                    <!-- Under Construction badge -->
                    <span class="absolute top-3 right-3 bg-amber-400 text-white text-[10px] font-bold px-2 py-0.5 rounded-full z-10 shadow-sm">
                        Under Construction
                    </span>
                    <img src="./assets/images/menu/k-eco-logo.png" alt="K-ECO" 
                         class="h-[100px] object-contain group-hover:scale-105 transition-transform duration-300">
                </div>
            </div>

            <!-- UCO CARD -->
            <div class="w-full sm:w-[270px]" [routerLink]="'/uco/dashboard'">
                <div class="group h-[200px] w-full bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer flex items-center justify-center p-6">
                    <img src="./assets/images/menu/kite-env-logo.png" alt="KITE-ENV" 
                         class="h-[100px] object-contain group-hover:scale-105 transition-transform duration-300">
                </div>
            </div>
        </div>
    </div>
</div>